import { FC, useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import useOnClickOutside from '../../../hooks/useOnClickOutside';
import './styles.scss';
import { useLocation } from 'react-router-dom';

export const CardMenu: FC<{
  userType: string;
  roomId: number;
  setPopupToggle: Function;
  setPopupContantType: Function;
  roomState: string;
  isHomeSpace: boolean;
}> = observer(
  ({
    userType,
    roomId,
    setPopupContantType,
    setPopupToggle,
    roomState,
    isHomeSpace,
  }) => {
    const [settings, setSettings] = useState<boolean>(false);
    const [actions, setActions] = useState<
      Array<{ icon: string; text: string; id: number; type: string }>
    >([]);
    const blockef = useRef<any>();

    const roomStateTypes: { [key: string]: string } = {
      1: 'public',
      2: 'draft',
      3: 'private',
    };
    const allActions = [
      {
        icon: 'icon-rename',
        text: 'Rename',
        id: 1,
        type: 'rename',
      },
      {
        icon: 'icon-remove',
        text: 'Delete',
        id: 2,
        type: 'delete',
      },
      {
        icon: 'icon-copy-link',
        text: 'Copy link',
        id: 3,
        type: 'copy',
      },
      {
        icon: 'icon-public',
        text: 'Make public',
        id: 4,
        type: 'public',
      },
      {
        icon: 'icon-key',
        text: 'Make private',
        id: 5,
        type: 'private',
      },
      {
        icon: 'icon-eye-closed',
        text: 'Make draft',
        id: 6,
        type: 'draft',
      },
    ];
    const { pathname } = useLocation();

    const handleActionClick = (e: any, type: string) => {
      e.stopPropagation();
      if (type === 'copy') {
        const url = pathname.includes('copia')
          ? `${window.location.origin}${pathname}/${roomId}`
          : `${window.location.origin}/room/${roomId}`;

        navigator.clipboard.writeText(url);

        setActions((prev) =>
          prev.map((el) => {
            if (el.type === 'copy') {
              el.text = 'Copied';
            }
            return el;
          }),
        );
      } else {
        setPopupContantType(type);
        setPopupToggle(true);
        closePopup();
      }
    };
    const handleSettingsClick = (e: any) => {
      e.stopPropagation();
      if (settings) closePopup();
      else setSettings(true);
    };

    const closePopup = () => {
      setActions((prev) =>
        prev.map((el) => {
          if (el.type === 'copy') {
            el.text = 'Copy link';
          }
          return el;
        }),
      );
      setSettings(false);
    };

    useOnClickOutside(blockef, closePopup);

    useEffect(() => {
      const userActions: Array<{
        icon: string;
        text: string;
        id: number;
        type: string;
      }> = [];
      if (userType === 'default' || isHomeSpace) {
        allActions.forEach((action) => {
          if (action.type === 'copy') userActions.push(action);
        });
      } else if (userType === 'admin') {
        allActions.forEach((action) => {
          if (
            action.type != 'delete' &&
            action.type != 'rename' &&
            action.type != roomStateTypes[roomState]
          )
            userActions.push(action);
        });
      } else if (userType === 'owner') {
        allActions.forEach((action) => {
          if (action.type != roomStateTypes[roomState])
            userActions.push(action);
        });
      }
      setActions(userActions);
    }, [userType, roomState]);

    return (
      <div className="cardMenuHolder" ref={blockef}>
        <i className="icon-horizonal-more cardMenuHolderIcon" onClick={handleSettingsClick} />
        {settings && (
          <div className="cardMenu">
            {actions?.map(
              (action: {
                icon: string;
                text: string;
                id: number;
                type: string;
              }) => (
                <div
                  key={action.id}
                  className="cardMenuRow"
                  onClick={(e) => handleActionClick(e, action.type)}
                >
                  <i className={action.icon} />
                  <p className="cardMenuRowTxt">{action.text}</p>
                </div>
              ),
            )}
          </div>
        )}
      </div>
    );
  },
);
